import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  data () {
    return {
      createInvoices: {
        show: false,
        title: 'Create Invoice',
        submitButtonText: 'Create',
        form: null
      }
    }
  },
  computed: {
    ...mapGetters({
      getInvoices: 'finances/getInvoices',
      getOwnBankDetails: 'finances/getOwnBankDetails',
      getStatuses: 'finances/getStatuses',
      getProjects: 'projects/getProjects',
      getTemplates: 'finances/getTemplates',
      getClientsBankDetailsAll: 'finances/getClientsBankDetailsAll',
      getInvoicesTypes: 'finances/getInvoicesTypes',
      getIsModalLoading: 'finances/getIsModalLoading'
    }),
    getActualProjects () {
      return this.getProjects
        .filter(project => project.project_status.name !== 'done')
    }
  },
  methods: {
    fetchInvoiceFormData () {
      return Promise.all([
        this.fetchAllBankDetails(),
        this.fetchInvoicesStatuses(),
        this.fetchProjects(),
        this.fetchAllUsers(),
        this.fetchTemplates(),
        this.fetchInvoicesTypes()
      ])
    },
    async fetchProjects () {
      return this.$api.projects.getProjects()
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    async fetchAllBankDetails () {
      return this.$api.finances.getBankDetailsAll()
    },
    async fetchAllClientBankDetails () {
      return this.$api.finances.getClientsBankDetailsAll()
    },
    async fetchTemplates () {
      return this.$api.finances.getInvoicesTemplate()
    },
    async fetchInvoicesStatuses () {
      return this.$api.finances.getInvoicesStatuses()
    },
    async fetchInvoicesTypes () {
      return this.$api.finances.getInvoicesTypes()
    },
    prepareDataForEditAndCreateRequest (fields) {
      let newFields = cloneDeep(fields)

      newFields.issue_date.value = this._toLocalTime(newFields.issue_date.value)
      newFields.due_date.value = this._toLocalTime(newFields.due_date.value)
      if (newFields.paid_date) {
        newFields.paid_date.value = this._toLocalTime(newFields.paid_date.value)
      }

      if (fields.invoice_type.value.id === 1) {
        newFields.periods.value = []
        newFields.specialisations.value = []
      }

      if (fields.invoice_type.value.id === 2) {
        newFields.items.value = []
        newFields.specialisations.value = []
      }

      if (fields.invoice_type.value.id === 3) {
        newFields.items.value = []
        newFields.periods.value = []
      }

      if (fields.invoice_type.value.id === 4) {
        newFields.items.value = []
        newFields.periods.value = []
        newFields.specialisations.value = []
      }

      if (!!newFields.periods.value) {
        newFields.periods.value = newFields.periods.value.map(item => {
          return {
            ...item,
            user_id: item.user.id,
            date_from: this._toLocalTime(item.date_from),
            date_to: this._toLocalTime(item.date_to)
          }
        })
      }
      if (!!newFields.items.value) {
        newFields.items.value = newFields.items.value.map(item => {
          return {
            ...item,
            user_id: item.user.id,
            date_from: this._toLocalTime(item.date_from),
            date_to: this._toLocalTime(item.date_to)
          }
        })
      }
      let data = {}

      for (let key in newFields) {
        const field = newFields[key]
        const name = field['name']
        const value = field['value']
        if (!value) {
          continue
        }
        if (value) {
          data[name] = typeof value === 'object' && !(value instanceof Array) ? value[field['valueField']] : value
        }
      }
      if (newFields.auto_fill.value) {
        data['auto_fill'] = newFields.auto_fill.value
      }
      data['custom_file'] = newFields.custom_file.value
      return data
    },
    async validateFields (fields) {
      if (fields.items.value && fields.items.value.some(item => item.hour_cost == '0')) {
        const createWithZeroHourCost = await this.$root.$confirm.open(
          '',
          'Some of employees have hourly rate = $0. Are you sure ?'
        )
        return createWithZeroHourCost
      }
      return true
    },
    updateInvoice (fields) {
      return new Promise((resolve, reject) => {
        const data = this.prepareDataForEditAndCreateRequest(fields)
        // this._toggleDataPageLoading(async () => {
        this.$store.dispatch('finances/setIsModalLoading', true)
        this.$api.finances.updateInvoices(data)
          .then(response => {
            this.$snotify.success(
              'Invoice successfully saved',
              'Success',
              this.$store.state.snotify
            )
            resolve(response)
          }, error => {
            this.outputErrorNotification(error)
            reject(error)
          })
          .finally(() => {
            this.$store.dispatch('finances/setIsModalLoading', false)
          })
        // })
      })
    },
    createInvoice (fields) {
      return new Promise((resolve, reject) => {
        const data = this.prepareDataForEditAndCreateRequest(fields)
        this.$store.dispatch('finances/setIsModalLoading', true)
        this._toggleDataPageLoading(async () => {
          await this.$api.finances.createInvoices(data)
            .then(response => {
              this.$snotify.success(
                'Invoice successfully created',
                'Success',
                this.$store.state.snotify
              )
              resolve(response)
            }, error => {
              this.outputErrorNotification(error)
              reject(error)
            })
            .finally(() => {
              this.$store.dispatch('finances/setIsModalLoading', false)
            })
        })
      })
    },
    outputErrorNotification (error) {
      if (error.response) {
        var errors = Object.values(error.response.data.errors)

        for (var i = 0; i < errors.length; i++) {
          if (errors[i][0]) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        }
      }
    }
  }
}
